import { render, staticRenderFns } from "./NoTemplatesBlock.vue?vue&type=template&id=16bc4e54&scoped=true&"
import script from "./NoTemplatesBlock.vue?vue&type=script&lang=js&"
export * from "./NoTemplatesBlock.vue?vue&type=script&lang=js&"
import style0 from "./NoTemplatesBlock.vue?vue&type=style&index=0&id=16bc4e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc4e54",
  null
  
)

export default component.exports